'use client'

import { useMemo } from 'react'

import { TruncatedTextCell } from '@/components/atomic/truncated-text-cell'
import { useGetOrganizationProfileQuery } from '@/legacy-api/organizations-slice'
import { PLACEHOLDER } from '@/utils/presentation/formatting'

interface OrganizationNameCellProps {
  organizationId: string | null | undefined
}

export function OrganizationNameCell({
  organizationId,
}: OrganizationNameCellProps) {
  const { data: organizationProfile } = useGetOrganizationProfileQuery()

  const organizationName = useMemo(() => {
    if (!organizationId || !organizationProfile) return null

    // Check if it's the parent organization
    if (organizationProfile.id === organizationId) {
      return organizationProfile.name
    }

    // Check if it's one of the introducing brokers (child organizations)
    const childOrg = organizationProfile.introducing_brokers.find(
      (ib) => ib.id === organizationId,
    )
    if (childOrg) {
      return childOrg.name
    }

    return null
  }, [organizationId, organizationProfile])

  if (!organizationName) {
    return PLACEHOLDER
  }

  return <TruncatedTextCell text={organizationName} />
}
